export const membersData = [
  {
    id: 'D-123432',
    firstName: 'John',
    lastName: 'Johnson',
    agent: 'One Source (34560)',
    created: '01/15/2025',
    email: 'john.johnson@gmail.com',
    phone: '+1(703) 362-0211',
    product: 'Cigna Network Choice',
    option: 'Member/Individual Plan',
    amount: '$3,466.41',
  },
  {
    id: 'D-123433',
    firstName: 'Sarah',
    lastName: 'Williams',
    agent: 'One Source (34560)',
    created: '01/14/2025',
    email: 'sarah.williams@yahoo.com',
    phone: '+1(555) 123-4567',
    product: 'Cigna Network Choice',
    option: 'Member/Individual Plan',
    amount: '$1,325.17',
  },
  {
    id: 'D-123434',
    firstName: 'Michael',
    lastName: 'Brown',
    agent: 'One Source (34560)',
    created: '01/13/2025',
    email: 'michael.brown@outlook.com',
    phone: '+1(202) 555-7890',
    product: 'Cigna Network Choice',
    option: 'Member/Individual Plan',
    amount: '$5,962.26',
  },
  {
    id: 'D-123435',
    firstName: 'Emily',
    lastName: 'Davis',
    agent: 'One Source (34560)',
    created: '01/12/2025',
    email: 'emily.davis@gmail.com',
    phone: '+1(301) 456-7890',
    product: 'Cigna Network Choice',
    option: 'Member/Individual Plan',
    amount: '$787.72',
  },
  {
    id: 'D-123436',
    firstName: 'David',
    lastName: 'Miller',
    agent: 'One Source (34560)',
    created: '01/11/2025',
    email: 'david.miller@hotmail.com',
    phone: '+1(410) 789-0123',
    product: 'Cigna Network Choice',
    option: 'Member/Individual Plan',
    amount: '$3,509.77',
  },
  {
    id: 'D-123437',
    firstName: 'Lisa',
    lastName: 'Wilson',
    agent: 'One Source (34560)',
    created: '01/10/2025',
    email: 'lisa.wilson@gmail.com',
    phone: '+1(703) 234-5678',
    product: 'Cigna Network Choice',
    option: 'Member/Individual Plan',
    amount: '$2,150.33',
  },
  {
    id: 'D-123438',
    firstName: 'Robert',
    lastName: 'Moore',
    agent: 'One Source (34560)',
    created: '01/09/2025',
    email: 'robert.moore@yahoo.com',
    phone: '+1(202) 345-6789',
    product: 'Cigna Network Choice',
    option: 'Member/Individual Plan',
    amount: '$4,200.88',
  },
  {
    id: 'D-123439',
    firstName: 'Jennifer',
    lastName: 'Taylor',
    agent: 'One Source (34560)',
    created: '01/08/2025',
    email: 'jennifer.taylor@outlook.com',
    phone: '+1(301) 567-8901',
    product: 'Cigna Network Choice',
    option: 'Member/Individual Plan',
    amount: '$1,875.45',
  },
  {
    id: 'D-123440',
    firstName: 'Christopher',
    lastName: 'Anderson',
    agent: 'One Source (34560)',
    created: '01/07/2025',
    email: 'chris.anderson@gmail.com',
    phone: '+1(410) 678-9012',
    product: 'Cigna Network Choice',
    option: 'Member/Individual Plan',
    amount: '$3,100.22',
  },
  {
    id: 'D-123441',
    firstName: 'Amanda',
    lastName: 'Thomas',
    agent: 'One Source (34560)',
    created: '01/06/2025',
    email: 'amanda.thomas@hotmail.com',
    phone: '+1(703) 456-7890',
    product: 'Cigna Network Choice',
    option: 'Member/Individual Plan',
    amount: '$2,800.66',
  },
  {
    id: 'D-123442',
    firstName: 'James',
    lastName: 'Jackson',
    agent: 'One Source (34560)',
    created: '01/05/2025',
    email: 'james.jackson@yahoo.com',
    phone: '+1(202) 456-7890',
    product: 'Cigna Network Choice',
    option: 'Member/Individual Plan',
    amount: '$4,500.11',
  },
  {
    id: 'D-123443',
    firstName: 'Jessica',
    lastName: 'White',
    agent: 'One Source (34560)',
    created: '01/04/2025',
    email: 'jessica.white@gmail.com',
    phone: '+1(301) 678-9012',
    product: 'Cigna Network Choice',
    option: 'Member/Individual Plan',
    amount: '$1,650.99',
  },
  {
    id: 'D-123444',
    firstName: 'Daniel',
    lastName: 'Harris',
    agent: 'One Source (34560)',
    created: '01/03/2025',
    email: 'daniel.harris@outlook.com',
    phone: '+1(410) 789-0123',
    product: 'Cigna Network Choice',
    option: 'Member/Individual Plan',
    amount: '$3,750.44',
  },
  {
    id: 'D-123445',
    firstName: 'Ashley',
    lastName: 'Martin',
    agent: 'One Source (34560)',
    created: '01/02/2025',
    email: 'ashley.martin@hotmail.com',
    phone: '+1(703) 567-8901',
    product: 'Cigna Network Choice',
    option: 'Member/Individual Plan',
    amount: '$2,300.77',
  },
  {
    id: 'D-123446',
    firstName: 'Matthew',
    lastName: 'Thompson',
    agent: 'One Source (34560)',
    created: '01/01/2025',
    email: 'matthew.thompson@yahoo.com',
    phone: '+1(202) 567-8901',
    product: 'Cigna Network Choice',
    option: 'Member/Individual Plan',
    amount: '$4,100.33',
  },
  {
    id: 'D-123447',
    firstName: 'Stephanie',
    lastName: 'Garcia',
    agent: 'One Source (34560)',
    created: '12/31/2024',
    email: 'stephanie.garcia@gmail.com',
    phone: '+1(301) 789-0123',
    product: 'Cigna Network Choice',
    option: 'Member/Individual Plan',
    amount: '$1,950.55',
  },
  {
    id: 'D-123448',
    firstName: 'Andrew',
    lastName: 'Martinez',
    agent: 'One Source (34560)',
    created: '12/30/2024',
    email: 'andrew.martinez@outlook.com',
    phone: '+1(410) 890-1234',
    product: 'Cigna Network Choice',
    option: 'Member/Individual Plan',
    amount: '$3,300.88',
  },
  {
    id: 'D-123449',
    firstName: 'Nicole',
    lastName: 'Robinson',
    agent: 'One Source (34560)',
    created: '12/29/2024',
    email: 'nicole.robinson@hotmail.com',
    phone: '+1(703) 678-9012',
    product: 'Cigna Network Choice',
    option: 'Member/Individual Plan',
    amount: '$2,600.22',
  },
  {
    id: 'D-123450',
    firstName: 'Kevin',
    lastName: 'Clark',
    agent: 'One Source (34560)',
    created: '12/28/2024',
    email: 'kevin.clark@yahoo.com',
    phone: '+1(202) 678-9012',
    product: 'Cigna Network Choice',
    option: 'Member/Individual Plan',
    amount: '$4,800.66',
  },
  {
    id: 'D-123451',
    firstName: 'Rachel',
    lastName: 'Rodriguez',
    agent: 'One Source (34560)',
    created: '12/27/2024',
    email: 'rachel.rodriguez@gmail.com',
    phone: '+1(301) 890-1234',
    product: 'Cigna Network Choice',
    option: 'Member/Individual Plan',
    amount: '$1,750.11',
  },
  {
    id: 'D-123452',
    firstName: 'Brandon',
    lastName: 'Lewis',
    agent: 'One Source (34560)',
    created: '12/26/2024',
    email: 'brandon.lewis@outlook.com',
    phone: '+1(410) 901-2345',
    product: 'Cigna Network Choice',
    option: 'Member/Individual Plan',
    amount: '$3,450.99',
  },
  {
    id: 'D-123453',
    firstName: 'Lauren',
    lastName: 'Lee',
    agent: 'One Source (34560)',
    created: '12/25/2024',
    email: 'lauren.lee@hotmail.com',
    phone: '+1(703) 789-0123',
    product: 'Cigna Network Choice',
    option: 'Member/Individual Plan',
    amount: '$2,100.44',
  },
  {
    id: 'D-123454',
    firstName: 'Tyler',
    lastName: 'Walker',
    agent: 'One Source (34560)',
    created: '12/24/2024',
    email: 'tyler.walker@yahoo.com',
    phone: '+1(202) 789-0123',
    product: 'Cigna Network Choice',
    option: 'Member/Individual Plan',
    amount: '$4,350.77',
  },
  {
    id: 'D-123455',
    firstName: 'Megan',
    lastName: 'Hall',
    agent: 'One Source (34560)',
    created: '12/23/2024',
    email: 'megan.hall@gmail.com',
    phone: '+1(301) 901-2345',
    product: 'Cigna Network Choice',
    option: 'Member/Individual Plan',
    amount: '$1,825.33',
  },
  {
    id: 'D-123456',
    firstName: 'Ryan',
    lastName: 'Allen',
    agent: 'One Source (34560)',
    created: '12/22/2024',
    email: 'ryan.allen@outlook.com',
    phone: '+1(410) 012-3456',
    product: 'Cigna Network Choice',
    option: 'Member/Individual Plan',
    amount: '$3,600.55',
  },
];

export const pendingData = [
  {
    memberId: 'D-123432',
    firstName: '.....',
    lastName: '.......',
    dateCompleted: '01/01/2025',
  },
  {
    memberId: 'D-123432',
    firstName: '.....',
    lastName: '.......',
    dateCompleted: '01/01/2025',
  },
  {
    memberId: 'D-123432',
    firstName: '.....',
    lastName: '.......',
    dateCompleted: '01/01/2025',
  },
  {
    memberId: 'D-123432',
    firstName: '.....',
    lastName: '.......',
    dateCompleted: '01/01/2025',
  },
  {
    memberId: 'D-123432',
    firstName: '.....',
    lastName: '.......',
    dateCompleted: '01/01/2025',
  },
  {
    memberId: 'D-123432',
    firstName: '.....',
    lastName: '.......',
    dateCompleted: '01/01/2025',
  },
  {
    memberId: 'D-123432',
    firstName: '.....',
    lastName: '.......',
    dateCompleted: '01/01/2025',
  },
  {
    memberId: 'D-123432',
    firstName: '.....',
    lastName: '.......',
    dateCompleted: '01/01/2025',
  },
  {
    memberId: 'D-123432',
    firstName: '.....',
    lastName: '.......',
    dateCompleted: '01/01/2025',
  },
  {
    memberId: 'D-123432',
    firstName: '.....',
    lastName: '.......',
    dateCompleted: '01/01/2025',
  },
];

export const archiveData = [
  {
    memberId: 'D-123432',
    firstName: '••••••',
    lastName: '•••••••',
    completed: '01/01/2025',
    underwritten: '01/01/2025',
    by: 'J. B.',
    assignment: 'Tier 3.5',
  },
  {
    memberId: 'D-123432',
    firstName: '••••••',
    lastName: '•••••••',
    completed: '01/01/2025',
    underwritten: '01/01/2025',
    by: 'J. B.',
    assignment: 'Tier 3.5',
  },
  {
    memberId: 'D-123432',
    firstName: '••••••',
    lastName: '•••••••',
    completed: '01/01/2025',
    underwritten: '01/01/2025',
    by: 'J. B.',
    assignment: 'Tier 3.5',
  },
  {
    memberId: 'D-123432',
    firstName: '••••••',
    lastName: '•••••••',
    completed: '01/01/2025',
    underwritten: '01/01/2025',
    by: 'J. B.',
    assignment: 'DTQ',
  },
  {
    memberId: 'D-123432',
    firstName: '••••••',
    lastName: '•••••••',
    completed: '01/01/2025',
    underwritten: '01/01/2025',
    by: 'J. B.',
    assignment: 'Tier 3.5',
  },
  {
    memberId: 'D-123432',
    firstName: '••••••',
    lastName: '•••••••',
    completed: '01/01/2025',
    underwritten: '01/01/2025',
    by: 'J. B.',
    assignment: 'DTQ',
  },
  {
    memberId: 'D-123432',
    firstName: '••••••',
    lastName: '•••••••',
    completed: '01/01/2025',
    underwritten: '01/01/2025',
    by: 'J. B.',
    assignment: 'DTQ',
  },
  {
    memberId: 'D-123432',
    firstName: '••••••',
    lastName: '•••••••',
    completed: '01/01/2025',
    underwritten: '01/01/2025',
    by: 'J. B.',
    assignment: 'DTQ',
  },
  {
    memberId: 'D-123432',
    firstName: '••••••',
    lastName: '•••••••',
    completed: '01/01/2025',
    underwritten: '01/01/2025',
    by: 'J. B.',
    assignment: 'Tier 3.5',
  },
  {
    memberId: 'D-123432',
    firstName: '••••••',
    lastName: '•••••••',
    completed: '01/01/2025',
    underwritten: '01/01/2025',
    by: 'J. B.',
    assignment: 'Tier 3.5',
  },
  {
    memberId: 'D-123432',
    firstName: '••••••',
    lastName: '•••••••',
    completed: '01/01/2025',
    underwritten: '01/01/2025',
    by: 'J. B.',
    assignment: 'Tier 3.5',
  },
  {
    memberId: 'D-123432',
    firstName: '••••••',
    lastName: '•••••••',
    completed: '01/01/2025',
    underwritten: '01/01/2025',
    by: 'J. B.',
    assignment: 'DTQ',
  },
];

export const plansData = [
  {
    name: 'Health',
    status: 'Done',
    statusClass: 'status-done',
  },
  {
    name: 'Hospital',
    status: 'Pending',
    statusClass: 'status-pending',
  },
  {
    name: 'Critical Illness',
    status: 'Done',
    statusClass: 'status-done',
  },
  {
    name: 'Dental',
    status: 'Pending',
    statusClass: 'status-pending',
  },
  {
    name: 'Vision',
    status: 'Done',
    statusClass: 'status-done',
  },
  {
    name: 'Accident',
    status: 'Done',
    statusClass: 'status-done',
  },
];

export const dependentsData = [
  {
    id: '4434342',
    firstName: 'Garry',
    lastName: 'Tisa',
    relationship: 'Husband',
    dateOfBirth: '01/01/1990',
    age: 35,
    socialSecurityNumber: '234233112',
    smoker: false,
    weight: '170 lbs',
  },
];

export const paymentMethodsData = [
  {
    id: 1,
    type: 'VISA',
    method: 'ACH',
    name: 'Susanna Tisa',
    bank: 'UMB, NA',
    routing: '••••8043',
    account: '••••8043',
    address: '100, Oak Street, Kansas City',
    status: 'MO',
    zip: '64567',
    phone: '(000) 000-0000',
    isExpanded: false,
    isEditing: false,
  },
  {
    id: 2,
    type: 'VISA',
    method: 'ACH',
    name: 'Susanna Tisa',
    bank: 'UMB, NA',
    routing: '••••8043',
    account: '••••8043',
    address: '100, Oak Street, Kansas City',
    status: 'MO',
    zip: '64567',
    phone: '(000) 000-0000',
    isExpanded: false,
    isEditing: false,
  },
  {
    id: 3,
    type: 'VISA',
    method: 'ACH',
    name: 'Susanna Tisa',
    bank: 'UMB, NA',
    routing: '••••8043',
    account: '••••8043',
    address: '100, Oak Street, Kansas City',
    status: 'MO',
    zip: '64567',
    phone: '(000) 000-0000',
    isExpanded: false,
    isEditing: false,
  },
];

export const productsData = [
  {
    id: '1',
    name: 'Cigna Network Choice Fund PPO',
    subtitle: '5000 Classic 24-25',
    monthlyCost: '$820',
    productInfo: {
      product: 'Member / Individual',
      tier: '6.5',
      status: 'Inactive',
    },
    adminData: {
      id: '1234564',
      admin: 'Base Acuity',
      category: 'Cigna Network',
      subCategory: 'Medical',
    },
    paymentData: {
      status: 'Inactive - Eligible for Medicare',
      paid: 'Yes',
      payments: '12',
    },
    dates: {
      created: '01/01/2026',
      billing: '01/01/2026',
      renewal: '01/01/2026',
      active: '01/01/2026',
      inactive: '01/01/2026',
      nextBilling: '01/01/2026',
    },
  },
  {
    id: '2',
    name: 'Cigna Network Choice Fund PPO',
    subtitle: '5000 Classic 24-25',
    monthlyCost: '$820',
    productInfo: {
      product: 'Member / Individual',
      tier: '6.5',
      status: 'Active',
    },
    adminData: {
      id: '1234565',
      admin: 'Base Acuity',
      category: 'Cigna Network',
      subCategory: 'Medical',
    },
    paymentData: {
      status: 'Active',
      paid: 'Yes',
      payments: '12',
    },
    dates: {
      created: '01/01/2026',
      billing: '01/01/2026',
      renewal: '01/01/2026',
      active: '01/01/2026',
      inactive: '01/01/2026',
      nextBilling: '01/01/2026',
    },
  },
  {
    id: '3',
    name: 'Cigna Network Choice Fund PPO',
    subtitle: '5000 Classic 24-25',
    monthlyCost: '$820',
    productInfo: {
      product: 'Member / Individual',
      tier: '6.5',
      status: 'Active',
    },
    adminData: {
      id: '1234566',
      admin: 'Base Acuity',
      category: 'Cigna Network',
      subCategory: 'Medical',
    },
    paymentData: {
      status: 'Active',
      paid: 'Yes',
      payments: '12',
    },
    dates: {
      created: '01/01/2026',
      billing: '01/01/2026',
      renewal: '01/01/2026',
      active: '01/01/2026',
      inactive: '01/01/2026',
      nextBilling: '01/01/2026',
    },
  },
];

export const documentsData = [
  {
    id: 1,
    type: 'PDF',
    date: 'February 25, 2025 • 5:33 AM',
    category: 'Letter',
    label: 'Label',
    information: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 2,
    type: 'PDF',
    date: 'February 25, 2025 • 5:33 AM',
    category: 'Letter',
    label: 'Label',
    information: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 3,
    type: 'PDF',
    date: 'February 25, 2025 • 5:33 AM',
    category: 'Letter',
    label: 'Label',
    information: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 4,
    type: 'PDF',
    date: 'February 25, 2025 • 5:33 AM',
    category: 'Letter',
    label: 'Label',
    information: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 5,
    type: 'PDF',
    date: 'February 25, 2025 • 5:33 AM',
    category: 'Letter',
    label: 'Label',
    information: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 6,
    type: 'PDF',
    date: 'February 25, 2025 • 5:33 AM',
    category: 'Letter',
    label: 'Label',
    information: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 7,
    type: 'PDF',
    date: 'February 25, 2025 • 5:33 AM',
    category: 'Letter',
    label: 'Label',
    information: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 8,
    type: 'PDF',
    date: 'February 25, 2025 • 5:33 AM',
    category: 'Letter',
    label: 'Label',
    information: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 9,
    type: 'PDF',
    date: 'February 25, 2025 • 5:33 AM',
    category: 'Letter',
    label: 'Label',
    information: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 10,
    type: 'PDF',
    date: 'February 25, 2025 • 5:33 AM',
    category: 'Letter',
    label: 'Label',
    information: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 11,
    type: 'PDF',
    date: 'February 25, 2025 • 5:33 AM',
    category: 'Letter',
    label: 'Label',
    information: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
];

export const transactionsData = [
  {
    id: 1,
    type: 'Sale',
    status: 'Approved',
    method: 'List Bill',
    date: 'February 25, 2025 • 5:33 AM',
    dateBy: 'by Scheduler (120)',
    processor: 'List Bill',
    processorSub: 'Save',
    information: 'Cigna Network Choice...',
    informationSub: 'Payment 4 • 1/1/2025',
    response: 'Approved',
    responseSub: '043342',
    amount: '$3,466.41',
  },
  {
    id: 2,
    type: 'Sale',
    status: 'Approved',
    method: 'List Bill',
    date: 'February 25, 2025 • 5:33 AM',
    dateBy: 'by Scheduler (120)',
    processor: 'List Bill',
    processorSub: 'Save',
    information: 'Cigna Network Choice...',
    informationSub: 'Payment 4 • 1/1/2025',
    response: 'Approved',
    responseSub: '043342',
    amount: '$3,466.41',
  },
  {
    id: 3,
    type: 'Sale',
    status: 'Approved',
    method: 'List Bill',
    date: 'February 25, 2025 • 5:33 AM',
    dateBy: 'by Scheduler (120)',
    processor: 'List Bill',
    processorSub: 'Save',
    information: 'Cigna Network Choice...',
    informationSub: 'Payment 4 • 1/1/2025',
    response: 'Approved',
    responseSub: '043342',
    amount: '$3,466.41',
  },
  {
    id: 4,
    type: 'Sale',
    status: 'Approved',
    method: 'List Bill',
    date: 'February 25, 2025 • 5:33 AM',
    dateBy: 'by Scheduler (120)',
    processor: 'List Bill',
    processorSub: 'Save',
    information: 'Cigna Network Choice...',
    informationSub: 'Payment 4 • 1/1/2025',
    response: 'Approved',
    responseSub: '043342',
    amount: '$3,466.41',
  },
  {
    id: 5,
    type: 'Sale',
    status: 'Approved',
    method: 'List Bill',
    date: 'February 25, 2025 • 5:33 AM',
    dateBy: 'by Scheduler (120)',
    processor: 'List Bill',
    processorSub: 'Save',
    information: 'Cigna Network Choice...',
    informationSub: 'Payment 4 • 1/1/2025',
    response: 'Approved',
    responseSub: '043342',
    amount: '$3,466.41',
  },
  {
    id: 6,
    type: 'Sale',
    status: 'Approved',
    method: 'List Bill',
    date: 'February 25, 2025 • 5:33 AM',
    dateBy: 'by Scheduler (120)',
    processor: 'List Bill',
    processorSub: 'Save',
    information: 'Cigna Network Choice...',
    informationSub: 'Payment 4 • 1/1/2025',
    response: 'Approved',
    responseSub: '043342',
    amount: '$3,466.41',
  },
  {
    id: 7,
    type: 'Sale',
    status: 'Approved',
    method: 'List Bill',
    date: 'February 25, 2025 • 5:33 AM',
    dateBy: 'by Scheduler (120)',
    processor: 'List Bill',
    processorSub: 'Save',
    information: 'Cigna Network Choice...',
    informationSub: 'Payment 4 • 1/1/2025',
    response: 'Approved',
    responseSub: '043342',
    amount: '$3,466.41',
  },
  {
    id: 8,
    type: 'Sale',
    status: 'Approved',
    method: 'List Bill',
    date: 'February 25, 2025 • 5:33 AM',
    dateBy: 'by Scheduler (120)',
    processor: 'List Bill',
    processorSub: 'Save',
    information: 'Cigna Network Choice...',
    informationSub: 'Payment 4 • 1/1/2025',
    response: 'Approved',
    responseSub: '043342',
    amount: '$3,466.41',
  },
  {
    id: 9,
    type: 'Sale',
    status: 'Approved',
    method: 'List Bill',
    date: 'February 25, 2025 • 5:33 AM',
    dateBy: 'by Scheduler (120)',
    processor: 'List Bill',
    processorSub: 'Save',
    information: 'Cigna Network Choice...',
    informationSub: 'Payment 4 • 1/1/2025',
    response: 'Approved',
    responseSub: '043342',
    amount: '$3,466.41',
  },
  {
    id: 10,
    type: 'Sale',
    status: 'Approved',
    method: 'List Bill',
    date: 'February 25, 2025 • 5:33 AM',
    dateBy: 'by Scheduler (120)',
    processor: 'List Bill',
    processorSub: 'Save',
    information: 'Cigna Network Choice...',
    informationSub: 'Payment 4 • 1/1/2025',
    response: 'Approved',
    responseSub: '043342',
    amount: '$3,466.41',
  },
  {
    id: 11,
    type: 'Sale',
    status: 'Approved',
    method: 'List Bill',
    date: 'February 25, 2025 • 5:33 AM',
    dateBy: 'by Scheduler (120)',
    processor: 'List Bill',
    processorSub: 'Save',
    information: 'Cigna Network Choice...',
    informationSub: 'Payment 4 • 1/1/2025',
    response: 'Approved',
    responseSub: '043342',
    amount: '$3,466.41',
  },
  {
    id: 12,
    type: 'Sale',
    status: 'Approved',
    method: 'List Bill',
    date: 'February 25, 2025 • 5:33 AM',
    dateBy: 'by Scheduler (120)',
    processor: 'List Bill',
    processorSub: 'Save',
    information: 'Cigna Network Choice...',
    informationSub: 'Payment 4 • 1/1/2025',
    response: 'Approved',
    responseSub: '043342',
    amount: '$3,466.41',
  },
  {
    id: 13,
    type: 'Sale',
    status: 'Approved',
    method: 'List Bill',
    date: 'February 25, 2025 • 5:33 AM',
    dateBy: 'by Scheduler (120)',
    processor: 'List Bill',
    processorSub: 'Save',
    information: 'Cigna Network Choice...',
    informationSub: 'Payment 4 • 1/1/2025',
    response: 'Approved',
    responseSub: '043342',
    amount: '$3,466.41',
  },
  {
    id: 14,
    type: 'Sale',
    status: 'Approved',
    method: 'List Bill',
    date: 'February 25, 2025 • 5:33 AM',
    dateBy: 'by Scheduler (120)',
    processor: 'List Bill',
    processorSub: 'Save',
    information: 'Cigna Network Choice...',
    informationSub: 'Payment 4 • 1/1/2025',
    response: 'Approved',
    responseSub: '043342',
    amount: '$3,466.41',
  },
  {
    id: 15,
    type: 'Sale',
    status: 'Approved',
    method: 'List Bill',
    date: 'February 25, 2025 • 5:33 AM',
    dateBy: 'by Scheduler (120)',
    processor: 'List Bill',
    processorSub: 'Save',
    information: 'Cigna Network Choice...',
    informationSub: 'Payment 4 • 1/1/2025',
    response: 'Approved',
    responseSub: '043342',
    amount: '$3,466.41',
  },
  {
    id: 16,
    type: 'Sale',
    status: 'Approved',
    method: 'List Bill',
    date: 'February 25, 2025 • 5:33 AM',
    dateBy: 'by Scheduler (120)',
    processor: 'List Bill',
    processorSub: 'Save',
    information: 'Cigna Network Choice...',
    informationSub: 'Payment 4 • 1/1/2025',
    response: 'Approved',
    responseSub: '043342',
    amount: '$3,466.41',
  },
  {
    id: 17,
    type: 'Sale',
    status: 'Approved',
    method: 'List Bill',
    date: 'February 25, 2025 • 5:33 AM',
    dateBy: 'by Scheduler (120)',
    processor: 'List Bill',
    processorSub: 'Save',
    information: 'Cigna Network Choice...',
    informationSub: 'Payment 4 • 1/1/2025',
    response: 'Approved',
    responseSub: '043342',
    amount: '$3,466.41',
  },
  {
    id: 18,
    type: 'Sale',
    status: 'Approved',
    method: 'List Bill',
    date: 'February 25, 2025 • 5:33 AM',
    dateBy: 'by Scheduler (120)',
    processor: 'List Bill',
    processorSub: 'Save',
    information: 'Cigna Network Choice...',
    informationSub: 'Payment 4 • 1/1/2025',
    response: 'Approved',
    responseSub: '043342',
    amount: '$3,466.41',
  },
  {
    id: 19,
    type: 'Sale',
    status: 'Approved',
    method: 'List Bill',
    date: 'February 25, 2025 • 5:33 AM',
    dateBy: 'by Scheduler (120)',
    processor: 'List Bill',
    processorSub: 'Save',
    information: 'Cigna Network Choice...',
    informationSub: 'Payment 4 • 1/1/2025',
    response: 'Approved',
    responseSub: '043342',
    amount: '$3,466.41',
  },
  {
    id: 20,
    type: 'Sale',
    status: 'Approved',
    method: 'List Bill',
    date: 'February 25, 2025 • 5:33 AM',
    dateBy: 'by Scheduler (120)',
    processor: 'List Bill',
    processorSub: 'Save',
    information: 'Cigna Network Choice...',
    informationSub: 'Payment 4 • 1/1/2025',
    response: 'Approved',
    responseSub: '043342',
    amount: '$3,466.41',
  },
];

export const historyData = [
  {
    id: 1,
    date: 'February 25, 2025 • 5:33 AM',
    user: 'example@gmail.com',
    actionInformation: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 2,
    date: 'February 25, 2025 • 5:33 AM',
    user: 'example@gmail.com',
    actionInformation: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 3,
    date: 'February 25, 2025 • 5:33 AM',
    user: 'example@gmail.com',
    actionInformation: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 4,
    date: 'February 25, 2025 • 5:33 AM',
    user: 'example@gmail.com',
    actionInformation: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 5,
    date: 'February 25, 2025 • 5:33 AM',
    user: 'example@gmail.com',
    actionInformation: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 6,
    date: 'February 25, 2025 • 5:33 AM',
    user: 'example@gmail.com',
    actionInformation: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 7,
    date: 'February 25, 2025 • 5:33 AM',
    user: 'example@gmail.com',
    actionInformation: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 8,
    date: 'February 25, 2025 • 5:33 AM',
    user: 'example@gmail.com',
    actionInformation: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 9,
    date: 'February 25, 2025 • 5:33 AM',
    user: 'example@gmail.com',
    actionInformation: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 10,
    date: 'February 25, 2025 • 5:33 AM',
    user: 'example@gmail.com',
    actionInformation: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 11,
    date: 'February 25, 2025 • 5:33 AM',
    user: 'example@gmail.com',
    actionInformation: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
  {
    id: 12,
    date: 'February 25, 2025 • 5:33 AM',
    user: 'example@gmail.com',
    actionInformation: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
  },
];

export const groupsData = [
  {
    id: 'D-123432',
    label: 'Rose Cafe',
    representative: 'Amber Linz',
    city: 'NYC, NY',
    email: 'example@gmail.com',
    phone: '+1(703) 362-0211',
    policyHolders: '1,234',
    created: '01/01/2025',
    agent: 'One Source (34560)',
  },
  {
    id: 'D-123433',
    label: 'Blue Restaurant',
    representative: 'John Smith',
    city: 'LA, CA',
    email: 'john.smith@example.com',
    phone: '+1(555) 123-4567',
    policyHolders: '2,156',
    created: '01/02/2025',
    agent: 'One Source (34560)',
  },
  {
    id: 'D-123434',
    label: 'Green Bistro',
    representative: 'Sarah Johnson',
    city: 'Chicago, IL',
    email: 'sarah.johnson@example.com',
    phone: '+1(202) 555-7890',
    policyHolders: '987',
    created: '01/03/2025',
    agent: 'One Source (34560)',
  },
  {
    id: 'D-123435',
    label: 'Yellow Cafe',
    representative: 'Mike Brown',
    city: 'Houston, TX',
    email: 'mike.brown@example.com',
    phone: '+1(301) 456-7890',
    policyHolders: '1,543',
    created: '01/04/2025',
    agent: 'One Source (34560)',
  },
  {
    id: 'D-123436',
    label: 'Red Diner',
    representative: 'Emily Davis',
    city: 'Phoenix, AZ',
    email: 'emily.davis@example.com',
    phone: '+1(410) 789-0123',
    policyHolders: '876',
    created: '01/05/2025',
    agent: 'One Source (34560)',
  },
  {
    id: 'D-123437',
    label: 'Purple Kitchen',
    representative: 'David Miller',
    city: 'Philadelphia, PA',
    email: 'david.miller@example.com',
    phone: '+1(703) 234-5678',
    policyHolders: '2,345',
    created: '01/06/2025',
    agent: 'One Source (34560)',
  },
  {
    id: 'D-123438',
    label: 'Orange Grill',
    representative: 'Lisa Wilson',
    city: 'San Antonio, TX',
    email: 'lisa.wilson@example.com',
    phone: '+1(202) 345-6789',
    policyHolders: '1,678',
    created: '01/07/2025',
    agent: 'One Source (34560)',
  },
  {
    id: 'D-123439',
    label: 'Pink Bakery',
    representative: 'Robert Moore',
    city: 'San Diego, CA',
    email: 'robert.moore@example.com',
    phone: '+1(301) 567-8901',
    policyHolders: '1,234',
    created: '01/08/2025',
    agent: 'One Source (34560)',
  },
  {
    id: 'D-123440',
    label: 'Brown Deli',
    representative: 'Jennifer Taylor',
    city: 'Dallas, TX',
    email: 'jennifer.taylor@example.com',
    phone: '+1(410) 678-9012',
    policyHolders: '2,567',
    created: '01/09/2025',
    agent: 'One Source (34560)',
  },
  {
    id: 'D-123441',
    label: 'Gray Tavern',
    representative: 'Christopher Anderson',
    city: 'San Jose, CA',
    email: 'chris.anderson@example.com',
    phone: '+1(703) 456-7890',
    policyHolders: '1,890',
    created: '01/10/2025',
    agent: 'One Source (34560)',
  },
  {
    id: 'D-123442',
    label: 'Black Lounge',
    representative: 'Amanda Thomas',
    city: 'Austin, TX',
    email: 'amanda.thomas@example.com',
    phone: '+1(202) 456-7890',
    policyHolders: '1,456',
    created: '01/11/2025',
    agent: 'One Source (34560)',
  },
  {
    id: 'D-123443',
    label: 'White Bar',
    representative: 'James Jackson',
    city: 'Jacksonville, FL',
    email: 'james.jackson@example.com',
    phone: '+1(301) 678-9012',
    policyHolders: '2,123',
    created: '01/12/2025',
    agent: 'One Source (34560)',
  },
  {
    id: 'D-123444',
    label: 'Silver Pub',
    representative: 'Jessica White',
    city: 'Fort Worth, TX',
    email: 'jessica.white@example.com',
    phone: '+1(410) 789-0123',
    policyHolders: '1,789',
    created: '01/13/2025',
    agent: 'One Source (34560)',
  },
  {
    id: 'D-123445',
    label: 'Gold Club',
    representative: 'Daniel Harris',
    city: 'Columbus, OH',
    email: 'daniel.harris@example.com',
    phone: '+1(703) 567-8901',
    policyHolders: '2,456',
    created: '01/14/2025',
    agent: 'One Source (34560)',
  },
  {
    id: 'D-123446',
    label: 'Copper Inn',
    representative: 'Ashley Martin',
    city: 'Charlotte, NC',
    email: 'ashley.martin@example.com',
    phone: '+1(202) 567-8901',
    policyHolders: '1,567',
    created: '01/15/2025',
    agent: 'One Source (34560)',
  },
  {
    id: 'D-123447',
    label: 'Bronze Hall',
    representative: 'Matthew Thompson',
    city: 'Seattle, WA',
    email: 'matthew.thompson@example.com',
    phone: '+1(301) 789-0123',
    policyHolders: '2,789',
    created: '01/16/2025',
    agent: 'One Source (34560)',
  },
  {
    id: 'D-123448',
    label: 'Platinum Room',
    representative: 'Stephanie Garcia',
    city: 'Denver, CO',
    email: 'stephanie.garcia@example.com',
    phone: '+1(410) 890-1234',
    policyHolders: '1,345',
    created: '01/17/2025',
    agent: 'One Source (34560)',
  },
  {
    id: 'D-123449',
    label: 'Diamond Palace',
    representative: 'Andrew Martinez',
    city: 'Washington, DC',
    email: 'andrew.martinez@example.com',
    phone: '+1(703) 678-9012',
    policyHolders: '2,678',
    created: '01/18/2025',
    agent: 'One Source (34560)',
  },
  {
    id: 'D-123450',
    label: 'Emerald Garden',
    representative: 'Nicole Robinson',
    city: 'Boston, MA',
    email: 'nicole.robinson@example.com',
    phone: '+1(202) 678-9012',
    policyHolders: '1,234',
    created: '01/19/2025',
    agent: 'One Source (34560)',
  },
  {
    id: 'D-123451',
    label: 'Ruby House',
    representative: 'Kevin Clark',
    city: 'Nashville, TN',
    email: 'kevin.clark@example.com',
    phone: '+1(301) 890-1234',
    policyHolders: '1,890',
    created: '01/20/2025',
    agent: 'One Source (34560)',
  },
];